var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("dl", { staticClass: "formContainer", class: _vm.classappend }, [
    _c("dt", [_vm._t("label")], 2),
    _vm._v(" "),
    _c(
      "dd",
      [
        _vm.validate.$error
          ? [
              !_vm.validate.required
                ? _c("span", { staticClass: "errNote" }, [
                    _vm._v(_vm._s(_vm.label) + "を入力してください。"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.validate.passwordRule && _vm.hasPasswordRule
                ? _c("span", { staticClass: "errNote" }, [
                    _vm._v(
                      _vm._s(_vm.label) +
                        "は大文字英・小文字英・数字・記号の中から3種以上で入力してください。"
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              (!_vm.validate.minLength || !_vm.validate.maxLength) &&
              _vm.hasPasswordLength
                ? _c("span", { staticClass: "errNote" }, [
                    _vm._v(
                      "\n                パスワードは" +
                        _vm._s(_vm.validate.$params.minLength.min) +
                        "文字以上" +
                        _vm._s(_vm.validate.$params.maxLength.max) +
                        "文字以下で入力してください。\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.validate.sameAs && _vm.name == "confirm"
                ? _c("span", { staticClass: "errNote" }, [
                    _vm._v(
                      "新しいパスワードが確認欄のパスワードと一致していません。"
                    ),
                  ])
                : _vm._e(),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "pswdShowHide" }, [
          _vm.inputType === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.validate.$model,
                    expression: "validate.$model",
                  },
                ],
                staticClass: "regular",
                attrs: {
                  name: _vm.name,
                  placeholder: _vm.placeholder,
                  type: "checkbox",
                },
                domProps: {
                  checked: Array.isArray(_vm.validate.$model)
                    ? _vm._i(_vm.validate.$model, null) > -1
                    : _vm.validate.$model,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.validate.$model,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.validate, "$model", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.validate,
                            "$model",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.validate, "$model", $$c)
                    }
                  },
                },
              })
            : _vm.inputType === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.validate.$model,
                    expression: "validate.$model",
                  },
                ],
                staticClass: "regular",
                attrs: {
                  name: _vm.name,
                  placeholder: _vm.placeholder,
                  type: "radio",
                },
                domProps: { checked: _vm._q(_vm.validate.$model, null) },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.validate, "$model", null)
                  },
                },
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.validate.$model,
                    expression: "validate.$model",
                  },
                ],
                staticClass: "regular",
                attrs: {
                  name: _vm.name,
                  placeholder: _vm.placeholder,
                  type: _vm.inputType,
                },
                domProps: { value: _vm.validate.$model },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.validate, "$model", $event.target.value)
                  },
                },
              }),
          _vm._v(" "),
          _c(
            "i",
            {
              class: _vm.iconClass,
              attrs: { tabIndex: "0", "aria-label": "パスワード表示/非表示" },
              on: {
                click: _vm.toggle,
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.toggle.apply(null, arguments)
                },
              },
            },
            [_vm._v("パスワード表示/非表示")]
          ),
        ]),
        _vm._v(" "),
        _vm._t("note"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }